import { LanguageFilled } from '@/assets/icons';
import { cn } from '@/lib/utils';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  RadioGroup,
  RadioGroupItem,
} from '@opaz/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  variant?: 'ghost' | 'secondary';
  className?: string;
  showIcon?: boolean;
  showText?: boolean;
}

export const LanguageSwitcher = ({
  variant = 'ghost',
  showIcon = true,
  showText = true,
  className,
}: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const [isLanguageSelectOpen, setIsLanguageSelectOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsLanguageSelectOpen(false);
  };

  return (
    <DropdownMenu open={isLanguageSelectOpen} onOpenChange={setIsLanguageSelectOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} className={cn('no-underline', className)}>
          {showIcon && <LanguageFilled />}
          {showText && (i18n.language === 'en' ? 'English' : 'العربية')}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-[200px] px-4 py-6 z-[102]" forceMount>
        <RadioGroup size="small" onValueChange={changeLanguage} value={i18n.language} dir={i18n.dir()}>
          {i18n.language !== 'en' && <RadioGroupItem value="en">English</RadioGroupItem>}
          {i18n.language !== 'ar' && <RadioGroupItem value="ar">العربية</RadioGroupItem>}
        </RadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
